import axiosInstance from "../AxiosInit/AxiosInstance";

export const getEndorsementPolicyDetails = (corporate_id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!corporate_id) {
        return reject("Corporate ID is required.");
      }

      axiosInstance
        .post(`/corporate_endorsement_policy_details/${corporate_id}`)
        .then((response) => {
          const { data, status } = response;

          if (status === 200 && data.policy_details && data.policy_details.length > 0) {
            resolve(data.policy_details[0]);
          } else {
            reject("Data not found");
          }
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
          reject(errorMessage);
        });
    });
  };
};

export const getCorporateEndorsementRackRates = (policy_id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!policy_id) {
        return reject("Corporate ID is required.");
      }
      const url = `/get_corporate_endorsementcalculation_rackrates_details/${policy_id}`;
      axiosInstance
        .get(url)
        .then((response) => {
          const { data, status } = response;
          if (status === 200 && data.rack_rates && data.rack_rates.length > 0) {
            const formattedData = data.rack_rates.map(rate => ({
              ageGroup: rate.age_group,
              sumInsured: rate.sum_insured,
              annualPremium: rate.annual_premium,
              premiumPerDay: rate.premium_per_day,
              totalDays: null,
              memberCount: null,
              additionPremium: null
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.error(`CRITICAL: The API endpoint "${url}" was not found (404). Please verify the URL path in your actions file against your backend's route definition.`);
            reject("Could not find the corporate rack rates API endpoint.");
          } else {
            const errorMessage = error.response?.data?.message || "An unexpected error occurred while fetching corporate rack rates.";
            console.error("Corporate Rack Rate fetch error:", error);
            reject(errorMessage);
          }
        });
    });
  };
};

export const getEndorsementCalculation = (policyId, employeeFile) => {
  return (dispatch) => {
    const formData = new FormData();
    formData.append("ref_policy_id", policyId);
    formData.append("employee_data", employeeFile);
    return axiosInstance
      .post("/corporate_endorsementcalculation_calculated_data", formData, {
        headers: {
          Authorization: `Bearer_TOKEN_HERE`,
        },
      })
      .then((response) => {
        const { data } = response.data;
        return Promise.resolve(data);
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message || "An unexpected error occurred.";
        return Promise.reject(errorMessage);
      });
  };
};

export const createEndorsementCalculation = (payload) => {
  return (dispatch) => {
    return axiosInstance
      .post("/create_corporate_endorsementcalculation_data", payload, {
        headers: {
          Authorization: `Bearer_TOKEN_HERE`,
        },
      })
      .then((response) => {
        const data = response.data;
        return Promise.resolve(data);
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message || "Failed to create corporate endorsement calculation";
        return Promise.reject(errorMessage);
      });
  };
};

export const getAllEndorsementCalculations = (corporateId, page = 1) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/get_all_corporate_endorsement_calculations_data/${corporateId}`, {
        headers: {
          Authorization: `Bearer_TOKEN_HERE`, // Replace dynamically in real use
        },
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  };
};

export const getEndorsementCalculationDetails = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/get_corporate_endorsementcalculations_data/${id}`, {
        headers: {
          Authorization: `Bearer YOUR_DYNAMIC_TOKEN_HERE`, // Replace this with dynamic token if managed by Redux or storage
        },
      })
      .then((response) => {
        return Promise.resolve(response.data); // Or dispatch an action here if needed
      })
      .catch((error) => {
        return Promise.reject(error?.response?.data?.message || "Something went wrong");
      });
  };
};

export const getEndorsementCalculationUploadedFile = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/get_corporate_endorsementcalculations_uploadedfile/${id}`, {
        headers: {
          Authorization: `Bearer YOUR_DYNAMIC_TOKEN_HERE`, 
        },
      })
      .then((response) => {
        return Promise.resolve(response.data); 
      })
      .catch((error) => {
        return Promise.reject(
          error?.response?.data?.message || "Failed to fetch the uploaded file."
        );
      });
  };
};

export const getEndorsementCalculationDataExport = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/get_corporate_endorsementcalculations_dataexport/${id}`, {
        headers: {
          Authorization: `Bearer YOUR_DYNAMIC_TOKEN_HERE`,
        },
      })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(
          error?.response?.data?.message || "Failed to fetch the exported file."
        );
      });
  };
};

export const getCorporateName = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/get_corporate_name/${id}`, {
        headers: {
          Authorization: `Bearer YOUR_DYNAMIC_TOKEN_HERE`,
        },
      })
      .then((response) => {
        return Promise.resolve(response.data?.corporate_name || []);
      })
      .catch((error) => {
        return Promise.reject(
          error?.response?.data?.message || "Failed to fetch corporate name."
        );
      });
  };
};